import React from 'react'
import styled, { css } from 'styled-components'
import { responsive } from '../../utils/responsive'

function mapDirection(dir) {
  if (dir === 'vertical') return 'column'
  if (dir === 'horizontal') return 'row'
  return dir || 'column'
}

const Root = styled.div`
  display: flex;
  width: 100%;
  ${(p) => responsive('flex-direction', mapDirection(p.$direction || p.theme.layout?.container?.direction), p.theme)}
  ${(p) => responsive('gap', p.$gap || p.theme.layout?.container?.gap || p.theme.space.lg, p.theme, (v) => (typeof v === 'number' ? `${v}px` : v))}
  ${(p) => responsive('align-items', p.$alignItems || p.theme.layout?.container?.alignItems || 'stretch', p.theme)}
  ${(p) => responsive('justify-content', p.$justify || p.theme.layout?.container?.justify || 'flex-start', p.theme)}
  ${(p) => responsive('flex-wrap', p.$wrap || p.theme.layout?.container?.wrap || 'nowrap', p.theme)}
  ${(p) => responsive('padding', p.$padding || p.theme.layout?.container?.padding || '0', p.theme)}
  ${(p) => p.$fluid ? css`max-width: 100%;` : css`max-width: ${p.$maxWidth || p.theme.layout?.container?.maxWidth || '1200px'}; margin: 0 auto;`}
`

export function Container({ children, direction = 'vertical', gap, alignItems, justify, wrap, padding, maxWidth, fluid = false, ...props }) {
  return (
    <Root $direction={direction} $gap={gap} $alignItems={alignItems} $justify={justify} $wrap={wrap} $padding={padding} $maxWidth={maxWidth} $fluid={fluid} {...props}>
      {children}
    </Root>
  )
}
